import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/kolodc/apple-touch-icon.png?url";
import icon from "@/styles/kolodc/favicon.ico?url";
import favicon from "@/styles/kolodc/favicon.svg?url";
import loginBg from "@/styles/kolodc/login-bg.jpg?url";
import logoDark from "@/styles/kolodc/logo-dark.svg?url";
import loginLogo from "@/styles/kolodc/logo.svg";
import logo from "@/styles/kolodc/logo.svg?url";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#ff7033",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "body-font-family":
            "Inter, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
        "code-font-family": "Menlo, Consolas, 'DejaVu Sans Mono', monospace",

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "header-logo-width": "90px",
        "header-logo-height": "20px",

        "sidenav-item-text-color": isDark ? "#FFFFFF" : "var(--color-text)",
        "sidenav-item-before-display": "none",
        "sidenav-item-hover-bg-color": "var(--color-primary)",
        "sidenav-item-hover-icon-color": "#FFFFFF",
        "sidenav-item-hover-text-color": "#FFFFFF",
        "sidenav-item-active-bg-color": "var(--color-primary)",
        "sidenav-item-active-icon-color": "#FFFFFF",
        "sidenav-item-active-text-color": "#FFFFFF",
        "sidenav-item-active-before-display": "none",

        //#region Login
        "login-intro-bg-image": `url("${loginBg}")`,
        "login-body-bg-color": "var(--color-text)",
        "login-body-bg-image": "",
        "login-body-bg-size": "cover",
        "login-body-text-color": "var(--color-white)",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-text-align": "left",
        "login-intro-flex-direction": "column",
        "login-intro-justify-content": "flex-end",
        "login-intro-align-items": "flex-start",
        "login-intro-padding": "60px",
        "login-title-font-size": "64px",
        "login-title-text-color": "",
        "login-title-font-weight": 600,
        "login-title-line-height": 1.3,
        "login-title-max-width": "380px",
        "login-title-padding": "0",
        "login-subtitle-font-size": "24px",
        "login-subtitle-max-width": "420px",

        "login-form-title-font-size": "20px",
        "login-form-bg-color": "var(--color-white)",
        "login-form-text-color": "var(--color-text)",
        "login-form-input-border-color": "#dbe2e9",
        "login-form-button-border-radius": "var(--input-border-radius)",
        "login-form-or-text-color": "#dbe2e9",
        "login-form-or-border-color": "#dbe2e9",
        "login-form-google-bg-color": "#007bf5",
        "login-form-more-text-color": "var(--color-white)",
        "login-form-more-bg-color": "#171b21",
        "login-form-more-border-color": "#171b21",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "180px",
        },
    },
};
